import { useRouteRef } from '@mainstage/core-plugin-api';
import { marketplaceProductExternalRouteRef } from '../routes';
import {
  MARKETPLACE_ACCESS_CONTROL_SUB_ROUTE,
  MARKETPLACE_PENDING_REQUEST_PANEL_OPEN_QUERY_PARAM,
} from '../utils';

/**
 * Creates a link to visit the pending requests panel for the given product ID, combining the following elements:
 * - marketplace product page base URL (external, defined in marketplace plugin)
 * - access control subroute
 * - query param to instantly open the pending requests panel after navigation
 * The link is consumed by notifications module and is sent along with in email notifications so it should be changed carefully
 * @param productId
 * @returns
 */
export const getProductPendingRequestsLink = (
  marketplaceProductBaseUrl: string,
) => {
  const params = new URLSearchParams({
    [MARKETPLACE_PENDING_REQUEST_PANEL_OPEN_QUERY_PARAM]: 'true',
  });
  return `${marketplaceProductBaseUrl}${MARKETPLACE_ACCESS_CONTROL_SUB_ROUTE}?${params.toString()}`;
};

export const useProductPendingRequestsLink = (productId: number) => {
  const routeFunc = useRouteRef(marketplaceProductExternalRouteRef);
  return getProductPendingRequestsLink(routeFunc({ id: productId.toString() }));
};
